import { render, staticRenderFns } from "./DesignStudio.vue?vue&type=template&id=df26dcfc&"
import script from "./DesignStudio.vue?vue&type=script&lang=js&"
export * from "./DesignStudio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports